// with polyfills
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import permission from './directive/permission'
import style from './directive/style'
import store from './store/'
import i18n from './locales'
import { VueAxios } from './utils/request'
import ProLayout, { PageHeaderWrapper } from '@/components/ProLayout'
import FooterToolBar from '@/components/FooterToolbar'
import FileUpload from '@/components/FileUpload'
import themePluginConfig from '../config/themePluginConfig'
import { TableSetting } from '@/components'
// 字典数据组件
import DictData from '@/components/DictData'
// 字典标签组件
import DictTag from '@/components/DictTag'

import bootstrap from './core/bootstrap'
import VueClipboard from 'vue-clipboard2'
import {  calendar } from 'ant-design-vue'
Vue.use(calendar)
Vue.use(VueClipboard)
import './core/lazy_use' // use lazy load components
import './permission' // permission control
import './utils/filter' // global filter
import './global.less' // global style
import '@/assets/css/main.css' // ruoyi css main.css
import { getDicts } from '@/api/system/dict/data'
import { getConfigKey } from '@/api/system/config'
import {
  parseTime,
  resetForm,
  addDateRange,
  selectDictLabel,
  selectDictLabels,
  handleTree,
  tableSorter,
} from '@/utils/ruoyi'
import { download } from '@/utils/request'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'

import VueAMap from 'vue-amap'


import video from 'vue-video-player/src'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import SlideVerify from 'vue-monoplasty-slide-verify'
import VCalendar from 'v-calendar'; // 引入日历插件
 
Vue.use(VCalendar, {
  componentPrefix: 'vc',
});
Vue.use(video)
Vue.use(VueAMap)
Vue.use(SlideVerify)
// setTimeout(()=>{
//   localStorage.clear()
//   Vue.use(VueAMap);
// },0)

VueAMap.initAMapApiLoader({
  key: '32c03b8b4b37e5cf3231e1b6325a24f0', // 高德的key
  // 插件集合
  plugin: [
    'AMap.CircleEditor', // 圆形编辑器插件
    'AMap.Geolocation', // 定位控件，用来获取和展示用户主机所在的经纬度位置
    'AMap.Geocoder', // 地理编码与逆地理编码服务，用于地址描述与坐标间的相互转换
    'AMap.Autocomplete',
    'AMap.PlaceSearch',
    'AMap.CitySearch',
  ],
  // 高德 sdk 版本，默认为 1.4.4
  v: '1.4.4',
})
//高德的安全密钥
window._AMapSecurityConfig = {
  securityJsCode: 'bfb50db85201f92928ccdd2b915f2ff8',
}

Vue.use(Viewer)
Viewer.setDefaults({
  Options: {
    inline: true, //启用lnline模式
    button: true, //显示右上角关闭按钮
    navbar: true, //显示缩略图导航
    title: true, //显示当前图片的标题
    toolbar: true, //显示工具栏
    tooltip: true, //显示缩放百分比
    movable: true, //显示可移动
    zoomable: true, //图片是否可缩放
    rotatable: true, //图片是否可旋转
    scalable: true, //图片是否可翻转
    transition: true, //使用css3过度
    fullscreen: true, //播放时是否全屏
    keyboard: true, //是否支持键盘
    url: 'data-source', //设置大图片的url
  },
})

// 全局方法挂载
Vue.prototype.getDicts = getDicts
Vue.prototype.getConfigKey = getConfigKey
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.addDateRange = addDateRange
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels
Vue.prototype.download = download
Vue.prototype.handleTree = handleTree
Vue.prototype.tableSorter = tableSorter
Vue.config.productionTip = false

// mount axios to `Vue.$http` and `this.$http`
Vue.use(VueAxios)
// use pro-layout components
Vue.component('pro-layout', ProLayout)
Vue.component('page-container', PageHeaderWrapper)
Vue.component('page-header-wrapper', PageHeaderWrapper)
Vue.component('footer-tool-bar', FooterToolBar)
Vue.component('file-upload', FileUpload)
Vue.component('table-setting', TableSetting)
Vue.component('dict-tag', DictTag)

Vue.use(permission)
Vue.use(style)

DictData.install()
// main.js中写入点击防抖方法
const throttle = {
    bind: (el, binding) => {
      let throttleTime = binding.value // 防抖时间
      if (!throttleTime) { // 用户若不设置防抖时间，则默认1s
        throttleTime = 1000
      }
      let timer
      let disable = false
      el.addEventListener('click', event => {
        if (timer) {
          clearTimeout(timer)
        }
        if (!disable) { // 第一次执行(一点击触发当前事件)
          disable = true
        } else {
          event && event.stopImmediatePropagation()
        }
        timer = setTimeout(() => {
          timer = null
          disable = false
        }, throttleTime)
      }, true)
    }
  }
  Vue.directive('throttle', throttle);
  
window.umi_plugin_ant_themeVar = themePluginConfig.theme
new Vue({
  router,
  store,
  i18n,
  // init localstorage, vuex
  created: bootstrap,
  render: (h) => h(App),
}).$mount('#app')
